import React from "react";

export default function MainAboutUsSection(){
    const containerStyle = {
        width: '100%',
        height: '500px',
        color: '#F0EFEC',
        display: 'flex'
    }
    const imageStyle = {
        width: '100%',
        objectFit: 'cover',
        filter: 'grayscale(30%) blur(1px)'
    }
    return (
        <>
            <div style={containerStyle}>
                <img style={imageStyle} src="/resources/mainImageJFWelding.jpg"></img>
            </div>
        </>
    )
}